<div class="drag-cell" data-cell-action-type="linkLabelClick" [attr.data-automation-id]="automationId" draggable
    [dndDraggable]="params.data" (dndStart)="params.setDraggedItem?.(params.data)"
    (dndCanceled)="params.onDragCanceled?.()"
    [ngClass]="[params.inlineEdit(params.data) ? 'inline-edit' : '', params.node.isSelected() ? 'selected' : '', params.required(params.data) ? 'required-cell' : '']">
    <img class="drag-dots" src="assets/images/drag_grey.png" [attr.data-automation-id]="automationId + '-drag-button'">
    <res-custom-checkbox *ngIf="params.checkable" [ngModel]="params.node.selected" [disabled]="isDisabled"
        [labelPaddingLeft]="5" [labelPaddingRight]="20" [automationId]="automationId" [notClickable]="true">
    </res-custom-checkbox>
    <span *ngIf="!params.inlineEdit(params.data)"
        [attr.title]="tooltip"
        [attr.data-automation-id]="automationId + '-text'">{{params.value}}</span>
    <input *ngIf="params.inlineEdit(params.data)" type="text" (ngModelChange)="onChange()"
        [disabled]="params.inputDisabled" ondragstart="event.preventDefault();" [(ngModel)]="params.data.externalName"
        [attr.data-automation-id]="automationId + '-textinput'">
    <span *ngIf="params.required(params.data)" class="required-cell">Required</span>
</div>